import { useEffect, useState } from 'react';

const useHost = () => {
  const PRODUCTION_HOSTNAME = 'www.xing.com';
  const [isPreview, setIsPreview] = useState(false);
  useEffect(() => {
    setIsPreview(window?.location?.hostname !== PRODUCTION_HOSTNAME);
  }, []);

  return {
    isPreview,
  };
};

export default useHost;
